class ReorderManagement extends HTMLElement {
    constructor() {
        super();

        this.reorderInfo = JSON.parse(localStorage.getItem('br_reorder'));
        this.reorderStatusInterval = null;
        this.loadingModal = this.querySelector('.br-loadingAsyncModal');
        this.errorMessageToast = this.querySelector('.br-messageToast.-error');
        this.successMessageToast = this.querySelector('.br-messageToast.-success');
        this.successMessageToastFull = this.querySelector('.br-messageToast.-success p.fullReorderMessage');
        this.successMessageToastPartial = this.querySelector('.br-messageToast.-success p.partialReorderMessage');

        this.initializeReorderPidListener();
        //this.initializeDropdownListener();
    }

    /* --------------------------- LISTENERS - METHODS -------------------------- */

    initializeReorderPidListener() {
        if (!this.reorderStatusInterval && this.reorderInfo !== null) {
            this.initializeReorderStatusInterval();
        }

        window.addEventListener('reorder', () => {
            this.reorderInfo = JSON.parse(localStorage.getItem('br_reorder'));
            if (!this.reorderStatusInterval && this.reorderInfo !== null) {
                this.initializeReorderStatusInterval();
            }
        });
    }

    /* --------------------------- INTERVAL - METHODS --------------------------- */

    initializeReorderStatusInterval() {
        this.loadingModal.style.display = 'flex';
        this.reorderImportStatusManagement();

        this.reorderStatusInterval = setInterval(async () => {
            this.reorderImportStatusManagement();
        }, 10000);
    }

    clearReorderStatusInterval() {
        clearInterval(this.reorderStatusInterval);
        this.reorderStatusInterval = null;
    }

    /* --------------------------------- METHODS -------------------------------- */

    async reorderImportStatusManagement() {
        const importInfo = await this.handleImportReorderAsyncStatus();

        if (importInfo.errors && Object.keys(importInfo.errors).length && importInfo.status != 'done') {
            this.clearReorderStatusInterval();
            this.parseErrors(importInfo.errors);
            return;
        }

        if (importInfo.status === 'done') {
            this.clearReorderStatusInterval();
            this.loadCart(importInfo.data, importInfo.errors.length > 0);
        }
    }

    parseErrors(errors) {
        this.loadingModal.style.display = 'none';
        this.errorMessageToast.style.display = 'inherit';
        setTimeout(() => {
            this.errorMessageToast.style.display = 'none';
        }, [3000]);
        this.reorderInfo = null;
        localStorage.removeItem('br_reorder');
    }

    async loadCart(items, hasErrors) {
        this.loadingModal.style.display = 'none';
        localStorage.removeItem('br_reorder');
        setNewCart(items);
        this.successMessageToast.style.display = 'inherit';
        if (hasErrors) {
            this.successMessageToastPartial.style.display = 'block';
        } else {
            this.successMessageToastFull.style.display = 'block';
        }

        setTimeout(() => {
            this.reorderInfo = null;
            window.location.href = '/cart';
        }, 1000);
    }

    /* ------------------------------ HTTP REQUEST ------------------------------ */

    async handleImportReorderAsyncStatus() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: headers,
        };

        const response = await fetch(`/apps/berardi/orders/reorder/${this.reorderInfo.pid}/status`, requestOptions);
        const data = await response.json();
        return data;
    }
}

customElements.define('reorder-management', ReorderManagement);
